import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { useYbug } from "@homesusa/core";
import { AppProvider, AppType, ThemeProvider } from "@homesusa/layout";
import AppRoutes from "./routes.component";

export function App(): JSX.Element {
  useYbug();

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppProvider appType={AppType.UserManagement}>
          <Suspense fallback={<LinearProgress />}>
            <AppRoutes />
          </Suspense>
        </AppProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
